/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace whitespace */

import { Injectable }           from '@angular/core';
import { HttpClient, HttpParams }                                from '@angular/common/http';

import { HttpHeaders }           from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { User }                  from '@/models/user';


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class StorageService
 *
 * Remote access to Google Storage
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class StorageService {

  private userid: string = '';

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService
  ) {

  }

  /** fetch any headers we need to send along with our request */
  headers(): HttpHeaders {

    const user: User = this.auth.userOfSession;

    if (!user) {

      /* no user logged in */

      return null;
    }

    this.userid = user.username;

    return new HttpHeaders().set('Authorization', `Bearer ${user.token}`);
  }

  /** convert a string into a binary form but 8-bit ascii encoded.  Allow for unicode etc. */
  binaryKey(key: string): string {

    /* ref: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings */

    const codeUnits = new Uint16Array(key.length);

    let byteArray: number[] = [];

    for (let i = 0; i < codeUnits.length; i++) {

      let byte: number = key.charCodeAt(i);

      /* low byte first */

      byteArray.push(byte & 0xFF);

      /* high byte second */

      byteArray.push((byte >> 8) & 0xFF);
    }

    return btoa(String.fromCharCode(...byteArray));
  }

  /** fetch this URL as a Blob */
  public get(url: string) {

    const headers = this.headers();

    if (!headers) {

      return null;
    }

    const params  = new HttpParams().
      set('key',      url).
      set('bkey',     this.binaryKey(url)).
      set('delete',   'true');

    return this.http.get(`/backend/storage/download`, {
      headers,
      params,
      reportProgress: true,
      observe:        'events',
      responseType:   'blob'
    });

  }

}
